import { validateDateNotInFuture } from '../../../utils/validators';

const PreviousEmployerSection = {
  name: 'previousEmployer',
  title: "APPLICANT'S PREVIOUS EMPLOYER",
  container: 'collapse',
  GridProps: { xs: 12, marginTop: 2 },
  watchFields: ['previousJobDoesNotApply'],
  collapsed: ({ getValues }) =>
    getValues('previousJobDoesNotApply') === true ||
    getValues('previousJobDoesNotApply') === 'on',
  disabled: ({ getValues }) =>
    getValues('previousJobDoesNotApply') === true ||
    getValues('previousJobDoesNotApply') === 'on',
  fields: [
    {
      variant: 'checkbox',
      name: 'previousJobDoesNotApply',
      label: 'Does not apply (N/A)',
      overrideParentDisabled: true,
      GridProps: { xs: 12 },
      changeActions: [
        {
          type: 'updateField',
          target: 'previousJobPosition',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'previousJobAnnualSalary',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'previousJobStartDate',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'previousJobEndDate',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'previousJobEmployerName',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'previousJobEmployerPhone',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'previousJobSupervisorName',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'previousJobStreetAddress',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'previousJobCity',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'previousJobState',
          value: '',
          when: {
            eq: true,
          },
        },
        {
          type: 'updateField',
          target: 'previousJobZipCode',
          value: '',
          when: {
            eq: true,
          },
        },
      ],
    },
    {
      variant: 'text',
      name: 'previousJobPosition',
      label: 'Position',
      rules: {
        required: true,
      },
      GridProps: { xs: 12, sm: 4 },
    },
    {
      variant: 'currency',
      name: 'previousJobAnnualSalary',
      label: 'Annual Income',
      GridProps: { xs: 12, sm: 3 },
      rules: {
        required: true,
        min: 0.01,
      },
    },
    {
      variant: 'date',
      name: 'previousJobStartDate',
      label: 'Date From',
      GridProps: { xs: 12, sm: 2 },
      rules: {
        required: true,
        validate: (value, getValues) => {
          const previousJobEndDate = getValues('previousJobEndDate');

          if (previousJobEndDate && value >= previousJobEndDate) {
            return 'Date From must be before Date To';
          }

          return validateDateNotInFuture(value, 'Date From');
        },
      },
    },
    {
      variant: 'date',
      name: 'previousJobEndDate',
      label: 'Date To',
      GridProps: { xs: 12, sm: 2 },
      rules: {
        required: true,
        validate: (value, getValues) => {
          const previousJobStartDate = getValues('previousJobStartDate');

          if (previousJobStartDate && value <= previousJobStartDate) {
            return 'Date To must be after Date From';
          }

          return validateDateNotInFuture(value, 'Date To');
        },
      },
    },
    {
      variant: 'flexSpacer',
    },
    {
      variant: 'text',
      name: 'previousJobEmployerName',
      label: 'Employer Name',
      GridProps: { xs: 12, sm: 4 },
      rules: {
        required: true,
      },
    },
    {
      variant: 'phone',
      name: 'previousJobEmployerPhone',
      label: 'Employer Phone',
      GridProps: { xs: 12, sm: 3 },
      rules: {
        required: true,
      },
    },
    {
      variant: 'text',
      name: 'previousJobSupervisorName',
      label: 'Supervisor Name',
      GridProps: { xs: 12, sm: 4 },
      rules: {
        required: true,
      },
    },
    {
      variant: 'flexSpacer',
    },
    {
      variant: 'text',
      name: 'previousJobStreetAddress',
      label: 'Employer Street Address',
      GridProps: { xs: 12, sm: 4 },
      rules: {
        required: true,
      },
    },
    {
      variant: 'text',
      name: 'previousJobCity',
      label: 'City',
      GridProps: { xs: 12, sm: 3 },
      rules: {
        required: true,
      },
    },
    {
      variant: 'singleSelect',
      name: 'previousJobState',
      label: 'State/Province',
      GridProps: { xs: 12, sm: 3 },
      rules: {
        required: true,
      },
    },
    {
      variant: 'text',
      name: 'previousJobZipCode',
      label: 'Zip Code/Postal Code',
      GridProps: { xs: 12, sm: 2 },
      rules: {
        required: true,
      },
    },
  ],
};

export default PreviousEmployerSection;
